import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/storybook.vue
var o = {
	name: "DtIconStorybook",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--storybook"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Storybook",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		fill: "currentColor",
		d: "m3.973 3.92.62 16.51a1.003 1.003 0 0 0 .96.966l13.422.603a1.005 1.005 0 0 0 1.051-1.004V3.006a1.006 1.006 0 0 0-1.069-1.004l-1.103.07.08 2.307a.149.149 0 0 1-.082.139.15.15 0 0 1-.16-.016l-.744-.586-.88.668a.15.15 0 0 1-.24-.126l.094-2.266-11.005.688a1.006 1.006 0 0 0-.944 1.04Zm9.388 5.812c0 .39 2.636.204 2.989-.071 0-2.664-1.43-4.064-4.047-4.064-2.618 0-4.084 1.422-4.084 3.554 0 2.137 1.658 3.068 3.067 3.859 1.04.584 1.945 1.092 1.945 1.953 0 .568-.278.906-.891.906-.798 0-1.114-.408-1.076-1.794 0-.3-3.045-.394-3.138 0-.236 3.359 1.857 4.328 4.252 4.328 2.32 0 4.14-1.236 4.14-3.476 0-2.336-1.753-3.265-3.2-4.032-1.019-.54-1.887-1-1.887-1.815 0-.8.594-.906.946-.906.372 0 1.04.065.984 1.558Z"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=storybook.js.map